import * as Yup from 'yup';
import { SORTBY_OPTIONS, accessibilities } from '../../utils/constants';
import { useEffect, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { Form } from 'react-bootstrap';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import messages from '../AboutYou/messages';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const Accessibilities = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const ACCESSIBILITY_OTHER_ID = 7;
  const intl = useIntl();

  const accessibilitiesOptions = createLocalizedOptions(
    accessibilities,
    messages,
    SORTBY_OPTIONS.Name
  );

  const [otherDetail, setOtherDetail] = useState<string | undefined>(
    values.accessibilitiesOtherDetail
  );

  useEffect(() => {
    const accessibilitiesSchema = GetShema();
    updateSchema(accessibilitiesSchema);
    values.accessibilitiesOtherDetail =
      DisplayAccessibilitiesOtherDetailQuestion(values.accessibilityIds)
        ? otherDetail!
        : undefined;

    if (!DisplayAccessibilitiesOtherDetailQuestion(values.accessibilityIds)) {
      setOtherDetail(undefined);
    }
  }, [otherDetail, values.accessibilityIds]);

  const DisplayAccessibilitiesOtherDetailQuestion = (element: number[]) => {
    return element?.includes(ACCESSIBILITY_OTHER_ID);
  };

  const GetShema = () => {
    return {
      accessibilityIds: Yup.array(Yup.number()).min(
        1,
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      ),
      accessibilitiesOtherDetail: Yup.object().when('accessibilityIds', {
        is: (ids: number[]) => DisplayAccessibilitiesOtherDetailQuestion(ids),
        then: () =>
          Yup.string()
            .trim()
            .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED }))
      })
    };
  };

  return (
    <div>
      <SelectQuestion
        controlId="accessibilityIds"
        label={intl.formatMessage({ ...messages.accessibilities })}
        isMulti={true}
        options={accessibilitiesOptions}
        value={values.accessibilityIds}
        error={errors.accessibilityIds}
        setFieldValue={setFieldValue}
      />
      {values.accessibilityIds?.includes(ACCESSIBILITY_OTHER_ID) ? (
        <Form.Group controlId="accessibilitiesOtherDetail">
          <Form.Label className="input fw-bold">
            {intl.formatMessage({ ...messages.accessibilitiesText })}
          </Form.Label>
          <Form.Control
            name="accessibilitiesOtherDetail"
            type="textarea"
            placeholder={intl.formatMessage({
              ...messages.accessibilitiesDescription
            })}
            defaultValue={values.accessibilitiesOtherDetail}
            required
            onChange={(event: any) => setOtherDetail(event.target.value)}
            isInvalid={errors.accessibilitiesOtherDetail}
          />
          {errors.accessibilitiesOtherDetail &&
            DisplayAccessibilitiesOtherDetailQuestion(
              values.accessibilityIds
            ) && (
              <Form.Control.Feedback type="invalid">
                <FiAlertTriangle className="mb-1 me-1" />
                {errors.accessibilitiesOtherDetail}
              </Form.Control.Feedback>
            )}
        </Form.Group>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Accessibilities;
